import { useState, useEffect } from 'react';
import { calculateMaxHeight } from '../utils/tableUtils';

/**
 * Custom hook for managing table height based on window size and instruction state
 * @param {boolean} isInstructionOpen - Whether instruction panel is open
 * @returns {number} - Current max height
 */
export function useTableHeight(isInstructionOpen) {
  const [maxHeight, setMaxHeight] = useState(0);

  useEffect(() => {
    const updateHeight = () => setMaxHeight(calculateMaxHeight(isInstructionOpen));
    
    updateHeight();
    window.addEventListener('resize', updateHeight);
    
    return () => window.removeEventListener('resize', updateHeight);
  }, [isInstructionOpen]);

  return maxHeight;
}
